export const ALL_CHANNELS = 'All Channels';
export const EMAIL = 'Email';
export const TEXT = 'Text';
export const STATISTICS_TABS = [ALL_CHANNELS, EMAIL, TEXT];
